module.exports = __webpack_public_path__ + "img/2.c46d5927.jpg";